import React from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import {connect} from 'react-redux'
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import {useTranslation} from 'react-i18next';
import {deleteDeliverable} from "../../../../store/actions/store/DeliverableAction";
import { useHistory } from '../../../utils/reactRouterCompatibility';
import {getStoreWarehouseRoute} from "../../../../router/routes/store/factory/store";
import Alert from '@mui/material/Alert';
import Button from "../../inputs/Button";


const DeleteDialog = ({deliverable, open, setOpen, deleting, deleteDeliverable}) => {
    const {t} = useTranslation();
    const history = useHistory();

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        deleteDeliverable(deliverable.Catalog_Deliverable__)
            .then(() => history.push(getStoreWarehouseRoute()))
    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('confirm_delete_deliverable_title')}
            aria-describedby={t('confirm_delete_deliverable_title')}
            fullWidth
        >
            <DialogTitle id="deliverable-delete-title">{t('confirm_delete_deliverable_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="deliverable-delete-description">
                    <Alert severity='warning'>
                        {t('confirm_delete_deliverable_desc')}
                    </Alert>
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button variant='contained' color="primary" autoFocus onClick={handleClose} disabled={deleting}>
                    {t('back_btn')}
                </Button>
                <Button color="secondary" loading={deleting} disabled={deleting} endIcon={<DeleteIcon/>}
                        onClick={handleDelete}>
                    {t('delete_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        deleting: state.deliverable.deleting
    }
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        deleteDeliverable: (id) => dispatch(deleteDeliverable(id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDialog);